export type CommunityProps = {
  id: number
  name: string
  description?: string
  imageURL: string
  coverImageURL?: string
  imageDescription: string
  coverDescription?: string
  permissions?: Record<string, unknown>
  owner: string
  lastPostDate: number
  followersCount: number
  isOwner?: boolean
  isFollowing?: boolean
  ownerId?: number
  ownerUcode?: string
  ownerPictureUrl?: string
  isOwnerOrFollower?: boolean
  icon?: string
  idGroup?: number
  hasUnseenNewsOrCommentReplies?: boolean
  order?: number
}

export enum ConfigSteps {
  ACCESS_AND_PRIVACY,
  MEMBERS_AND_PERMISSIONS,
  UNBAN_MEBER,
  GENERAL_CONFIG
}

export type ToggleUnbanMemberCommunityModal = {
  action: 'open' | 'close' | 'openConfirmation' | 'closeConfirmation'
  community?: CommunityProps
  user?: {
    id: number
    name?: string
    userName?: string
    email?: string
    imagePath?: string
  }
  fromConfigurationSidebar?: boolean
}
